/** The default mount id. A mount contract only, never an MFE's CSS scope. */
export const DEFAULT_MFE_CONTAINER_ID = 'flipdish-micro-frontend';
